
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h6>{` `}</h6>
    <h1>{`Cookie policy`}</h1>
    <h2>{`General`}</h2>
    <p>{`Cette politique de gestion des cookies gère l’utilisation de cookies et technologies
similaires en tant qu’élément de votre usage de notre site web (le « site web ») et les services associés .Ce traitement est effectué par Partena Profesional en tant que responsable du traitement, dont le siège social est sis à Rue des chartreux 45, 1000 Bruxelles conformément à la législation en vigueur en matière de protection des données personnelles.`}</p>
    <p>{`Les cookies sont des petits fichiers texte qui sont enregistrés sur le disque dur de votre appareil et qui contiennent certaines informations, parmi lesquelles des données personnelles. Lorsque vous utilisez notre site web et/ou services, nous collectons et traitons également d’autres informations personnelles que via des cookies et technologies similaires. Pour en savoir plus, lisez notre politique de confidentialité.`}</p>
    <p><strong parentName="p">{` En continuant à utiliser notre site web et/ou services en cliquant sur
« continuer » après avoir été informé de l’usage des cookies et technologies
similaires, vous reconnaissez avoir lu attentivement cette politique de gestion
des cookies et êtes d’accord sans réserve. Comme décrit dans cette politique
de gestion des cookies, vous pouvez à tout moment modifier vos préférences
en matière de cookies. `}</strong></p>
    <p>{`Nous nous réservons le droit de modifier, compléter ou remplacer cette politique de gestion des cookies de temps en temps. De telles modifications, ajouts ou remplacements vous seront communiqués via notre site web et/ou services. Si vous n’êtes pas d’accord avec ces modifications, ajouts ou remplacements, nous vous demandons d’envoyer un e-mail à `}<u><a parentName="p" {...{
          "href": "mailto:privacy@partena.be"
        }}>{`privacy@partena.be`}</a></u>{`. Si nous ne recevons aucune communication de votre part dans les trois (3) jours ouvrables aprèscommunication des modifications, ajouts ou remplacements via notre site web ou services, vous êtes supposé avoir accepté ces modifications, ajouts ou remplacements.`}</p>
    <h2>{`Quels cookies et pourquoi`}</h2>
    <p>{`Lorsque vous visitez et/ou utilisez notre site web, nous plaçons des cookies ou
utilisons des technologies similaires pour collecter et traiter les données
personnelles. De tels cookies et technologies similaires contiennent entre autres les éléments suivants :`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Nom`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Objectif`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Période de conservation`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`dc_gtm_UA-#`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Statistical`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Google Tag Manager - Utilisé pour charger Google Analytics`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 jour`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`ga`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Statistical`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Google Analytics - Enregistre un ID unique qui est utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2 ans`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`gat`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Statistical`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Google Analytics - Utilisé par Google Analytics pour limiter le nombre de demandes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 jour`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`gid`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Statistical`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Google Tag Manager - Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 jour`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`vwo_uuid_v2`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Statistique`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`VWO - Utilisé pour afficher les tests fractionnés pour l'optimisation du site Web`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 an`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`fbp`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Facebook - Utilisé par Facebook pour fournir une série de produits publicitaires, tels que des offres en temps réel d'annonceurs externes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 jour`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`hjDonePolls`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hotjar - Se souvient si le visiteur a déjà répondu à un formulaire spécifique`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 an`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`hjIncludedInSample`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hotjar - Se souvient si le visiteur a été inclus dans un rapport d'échantillonnage pendant`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 an`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`hjid`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hotjar - Enregistre un ID unique qui est utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 an`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Fr`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Facebook - Utilisé par Facebook pour fournir une série de produits publicitaires, tels que des offres en temps réel de tiers`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`3 mois`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`#Visitor_id`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pardot - La valeur stockée via le cookie est un identifiant unique pour le visiteur`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`10 ans`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`lang`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Linkedin - Utilisé par Linkedin pour garder une trace de la session de langue sélectionnée par l'utilisateur`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Session`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bcookie`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Linkedin - Utilisé par Linkedin pour mesurer les intégrations Linkedin pendant`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2 ans`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`bscookie`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Linkedin - Utilisé par Linkedin pour mesurer les intégrations Linkedin`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2 ans`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`lidc`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Linkedin - Utilisé par Linkedin pour optimiser les impressions d'annonces`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 jour`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`UserMatchHistory`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Linkedin - Utilisé par Linkedin pour optimiser les impressions d'annonces pendant`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`29 jours`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`cid`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Adform - Utilisé par Adform pour optimiser les impressions d'annonces pendant`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2 mois`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`uid`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Adform - Utilisé par Adform pour optimiser les impressions d'annonces pendant d'annonces`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`2 mois`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`_`}{`hjTLDTest`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Marketing`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Hotjar - Utilisé par Hotjar pour enregistrer l'utilisation sur les sous-domaine`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Session`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`pctrk`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Statistique`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pardot - Utilisé par Pardot pour garder une trace des pages vues publiques.`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`1 an`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`NG_TRANSLATE_LANG_KEY`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Fonctionnel`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Pardot - Utilisé par Pardot pour garder une trace de la session de sélection de la langue`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Session`}</td>
        </tr>
      </tbody>
    </table>
    <h6>{` `}</h6>
    <p>{`Vous pouvez empêcher que des cookies soient enregistrés et vous pouvez
supprimer des cookies déjà enregistrés en modifiant les paramètres de votre
navigateur. Vous trouverez de l’aide concernant l’adaptation de ces paramètres sur le site web du navigateur que vous utilisez. Tenez compte du fait que la non-acceptation de cookies lors de la visite d’un site web peut entraîner le
dysfonctionnement de certaines (ou toutes les) fonctions du site web.`}</p>
    <ul>
      <li parentName="ul">{`Internet Explorer: `}<u><a parentName="li" {...{
            "href": "https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies"
          }}>{`https://support.microsoft.com/en-gb/help/17442/windows-internet-explorer-delete-manage-cookies`}</a></u></li>
      <li parentName="ul">{`Microsoft Edge: `}<u><a parentName="li" {...{
            "href": "http://windows.microsoft.com/en-gb/windows-10/edge-privacy-faq"
          }}>{`http://windows.microsoft.com/en-gb/windows-10/edge-privacy-faq`}</a></u></li>
      <li parentName="ul">{`Chrome: `}<u><a parentName="li" {...{
            "href": "https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop&hl=fe"
          }}>{`https://support.google.com/accounts/answer/61416?co=GENIE.Platform%3DDesktop`}{`&`}{`hl=fr`}</a></u></li>
      <li parentName="ul">{`Firefox: `}<u><a parentName="li" {...{
            "href": "https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences"
          }}>{`https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences`}</a></u></li>
      <li parentName="ul">{`Safari: `}<u><a parentName="li" {...{
            "href": "https://support.apple.com/nl-be/guide/safari/sfri11471/mac"
          }}>{`https://support.apple.com/nl-be/guide/safari/sfri11471/mac`}</a></u></li>
    </ul>
    <p>{`Si vous avez une plainte concernant le traitement de vos données personnelles par
nos soins, vous pouvez toujours prendre contact avec nous via l’adresse e-
mail `}<u><a parentName="p" {...{
          "href": "mailto:privacy@partena.be"
        }}>{`privacy@partena.be`}</a></u>{`.  Si vous n`}{`'`}{`êtes toujours pas satisfait de notre réponse, vous êtes libre de déposer une plainte auprès de l`}{`'`}{`autorité compétente en matière de protection des données, l`}{`'`}{`Autorité belge de protection des données, Drukpersstraat 35, 1000 Bruxelles, Tél +32 (0) 2 274 48 00, site Internet: `}<u><a parentName="p" {...{
          "href": "wwww.autoriteprotectiondonnees.be"
        }}>{`www.autoriteprotectiondonnees.be`}</a></u></p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;